import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import { default as Adal, AxiosAuthHttp } from 'vue-adal'
import store from './services/store'
import "@/style/global.css"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faLock, faSignOutAlt, faDownload, faCheckCircle, faFileDownload, faUserAlt, faExclamationCircle, faUserShield, faUserCog, faHome, faBook, faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText  } from '@fortawesome/vue-fontawesome'
import jQuery from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-select-bs4';
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-select-bs4/css/select.bootstrap4.css'
global.jQuery = jQuery
global.$ = jQuery
import axios from 'axios'
import VeeValidate from "vee-validate";
import { EnvironmentConfig } from "../src/services/constants"
import msal from "vue-msal";

// const graphApiBase = EnvironmentConfig._graphAPIBase
// const graphApiResource = EnvironmentConfig._graphAPIResource
const redirectURL = EnvironmentConfig._RedirectURL;
const tenantValue = EnvironmentConfig._TenantValue;
const clientIdValue = EnvironmentConfig._ClientIdValue;
const authorityURL = 'https://login.microsoftonline.com/';

Vue.use(msal, {
   auth: {
       // 'common' (multi-tenant gateway) or Azure AD Tenant ID
       tenant: tenantValue,
       // Application ID
       clientId: clientIdValue,
       // Host URI
       redirectUri: redirectURL,
       cacheLocation: 'localStorage',
       authority: authorityURL + tenantValue
   },
   // Set this to true for authentication on startup
   requireAuthOnInitialize: true,
   // Pass a vue-router object in to add route hooks with authentication and role checking
   router: router
})
//Vue.use({
//    install(vue) {
//        // Configures an axios http client with a interceptor to auto-acquire tokens
//        vue.prototype.$graphApi = AxiosAuthHttp.createNewClient({
//            // Required Params
//            axios: axios,
//            resourceId: graphApiResource, // Resource id to get a token against
//            baseUrl: graphApiBase, // Base url to configure the client with
//            onTokenSuccess(http, context) { // Token success hook
//                // When an attempt to retrieve a token is successful, this will get called.
//                // This enables modification of the client after a successful call.
//                if (context.user) {
//                    // Setup the client to talk with the Microsoft Graph API
//                    http.defaults.baseURL = `${graphApiBase}/${context.user.profile.tid}`
//                }
//            },
//            onTokenFailure(error) { // Token failure hook
//                // When an attempt to retrieve a token is not successful, this will get called.
//                window.console.log(error)
//            }
//        })
//    }
//})
Vue.use(VeeValidate);
Vue.prototype.$ajax = axios;
Vue.config.productionTip = false
library.add(faUserSecret, faUser, faLock, faSignOutAlt, faDownload, faCheckCircle, faFileDownload, faUserAlt, faExclamationCircle, faUserShield, faUserCog, faHome, faBook)
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
axios.interceptors.request.use(
    (config) => {
        config.headers["Access-Control-Allow-Origin"] = "*";
        config.headers["Access-Control-Allow-Methods"] = "*";
        config.headers["Accept"] = "*/*";
        config.headers['Cache-Control'] = 'no-cache';
        config.headers['Pragma'] = 'no-cache';
        config.headers['Expires'] = 'Sat, 01 Jan 2000 00:00:00 GMT';
        config.headers["Content-Type"] = "application/json/x-www-form-urlencoded";
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
new Vue({
    router,
    store,
    components: { App, axios },
    render: h => h(App)
}).$mount('#app')